import React from "react";

import {
	ConfirmToast,
	ConfirmToastAction,
	ConfirmToastDescription,
	ConfirmToastProvider,
	ConfirmToastTitle,
} from "@/app/components/ui/toast.jsx";

const ExternalApplicationRegModal = ({ open, setOpen, applicationDetails }) => {
	const onConfirm = () => {
		console.log(applicationDetails);
		setOpen(false);
	};

	return (
		<ConfirmToastProvider>
			<ConfirmToast open={open} onOpenChange={setOpen}>
				<ConfirmToastTitle>Did you apply to this job?</ConfirmToastTitle>
				<ConfirmToastDescription>Let us know and we will help you track the application.</ConfirmToastDescription>
				<ConfirmToastAction onYes={() => onConfirm()} onNo={() => setOpen(false)} />
			</ConfirmToast>
		</ConfirmToastProvider>
	);
};

export default ExternalApplicationRegModal;
